import React, { useState } from "react";
import { Helmet } from "react-helmet";

import appConfig from "../../modules/appConfig";
import getPng from "../../utils/getPng";

export type HeadProps = {
  data?: {
    title: string;
    author: string;
    description: string;
    url: string;
  };
  imageName?: string;
  hideFromSearchEngines?: boolean;
};

export const Head = (props: HeadProps): React.ReactElement => {
  const { data, imageName, hideFromSearchEngines } = props;
  const title = data ? data.title : appConfig.title;
  const author = data ? data.author : appConfig.author;
  const description = data ? data.description : appConfig.description;
  const url = data ? data.url : appConfig.url;
  const noIndex = hideFromSearchEngines
    ? hideFromSearchEngines
    : appConfig.hideFromSearchEngines;
  const [image, setImage] = useState("");
  getPng(imageName).then((image) => setImage(image));

  return (
    <Helmet>
      {/* General tags */}
      <html lang="en" />
      <title>{title}</title>
      <meta name="author" content={author} />
      <meta name="description" content={description} />
      <meta name="keywords" content={appConfig.keywords} />
      <meta name="image" content={image} />

      {/* OpenGraph tags */}
      <meta property="og:title" content={title} />
      <meta property="og:author" content={author} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter Card tags */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content={image} />

      {noIndex && <meta name="robots" content="noindex" />}
    </Helmet>
  );
};

export default Head;
